import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Platform } from '@ionic/angular';
import { SessionService } from './Session/session.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  constructor(private platform: Platform,
    private sesi:SessionService,) {
      this.initializeApp();
    }
    initializeApp() {
    
      this.platform.ready().then(() => {
          window.addEventListener('beforeunload', () => {
          this.sesi.clearStoreAuthData();
          this.sesi.storeAuthData();
        });
      });
    } 
}
